package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.common.api.dtos.ChatPageMetadata
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.collections.CollectionNavigatorState
import horcrux.frontend.common.views.collections.editcollectionmenu.ManageChatPageMenuOptions
import react.FC
import react.Props

external interface ChatPageDetailsDialogProps : Props {
    var currentChatPageMetadata: ChatPageMetadata
    var globalAppState: GlobalAppState
}

private val ChatPageMetadata.displayString: String
    get() = this.collectionMetadata.displayString

val ChatPageDetailsDialog = FC<ChatPageDetailsDialogProps> { props ->
    MetadataDetailsDialog {
        this.title = ManageChatPageMenuOptions.CHAT_PAGE_DETAILS.viewName
        this.detailsText = props.currentChatPageMetadata.displayString
        this.showDialogState = props.globalAppState.collectionNavigatorState.showChatPageDetailsDialogState
    }
}
